"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOpenGlRenderer = void 0;
const validRenderers = ['angle', 'egl', 'swiftshader'];
const validateOpenGlRenderer = (option) => {
    if (!validRenderers.includes(option)) {
        throw new TypeError(`${option} is not a valid GL backend. Accepted values: ${validRenderers.join(', ')}`);
    }
    return option;
};
exports.validateOpenGlRenderer = validateOpenGlRenderer;
